// extracted by mini-css-extract-plugin
module.exports = {"containerFullTitle":"styles_containerFullTitle__MHe05","iconElite":"styles_iconElite__TFaKh"};